export const cartConstants = {
  FETCH_CART_START: "FETCH_CART_START",
  FETCH_CART_END: "FETCH_CART_END",
  ADD_TO_CART_PROCESSING: "ADD_TO_CART_PROCESSING",
  ADD_TO_CART_SUCCESS: "ADD_TO_CART_SUCCESS",
  ADD_TO_CART_FAILED: "ADD_TO_CART_FAILED",
  ADD_TO_CART_RESET: "ADD_TO_CART_RESET",
  REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
  CLEAR_CART: "CLEAR_CART",
  REQUEST_START: "REQUEST_START",
  REQUEST_END: "REQUEST_END",
  CHECKOUT_PROCESSING: "CHECKOUT_PROCESSING",
  CHECKOUT_SUCCESS: "CHECKOUT_SUCCESS",
  CHECKOUT_FAILURE: "CHECKOUT_FAILURE",
  CHARGE_CARD_SUCCESS: "CHARGE_CARD_SUCCESS",
  FETCH_WISHLIST_START: "FETCH_WISHLIST_START",
  FETCH_WISHLIST_END: "FETCH_WISHLIST_END",

  COME_FROM_ROUTE: "COME_FROM_ROUTE",
  ADD_TO_CART_OPERATION_PROCESSING: "ADD_TO_CART_OPERATION_PROCESSING",
  ADD_TO_CART_OPERATION: "ADD_TO_CART_OPERATION",
  ADD_TO_CART_OPERATION_RESET: "ADD_TO_CART_OPERATION_RESET",
};
